import * as firebase from 'firebase/app';
import Special from '../models/Special.js';
require('firebase/firestore');
require('firebase/storage');

const state = {
  allSpecials: [],
  specialToEdit: {}
};

const getters = {
  getSpecials: state => state.allSpecials,
  getSpecialToEdit: state => state.specialToEdit
};

const actions = {
  getAllSpecials({
    commit
  }) {
    firebase.firestore().collection("specials").onSnapshot(
      snapshot => {

        commit("setLoading", true);

        let specials = [];
        snapshot.forEach(doc => {
          let s = new Special(doc.id, doc.data().title, doc.data().description, null, doc.data().imageUrl, doc.data().fullPath, doc.data().created, doc.data().startDate, doc.data().endDate);
          specials.push(s);
        });
        commit("setSpecials", specials);
        commit("setLoading", false);
      },
      error => {
        commit("setLoading", false);
        console.error(error);
      }
    );
  },
  createSpecial({
    commit
  }, special) {
    let id = 0;

    firebase.firestore().collection("specials").add({
        title: special.title,
        description: special.description,
        created: special.created,
        startDate: special.startDate,
        endDate: special.endDate
      })
      .then(docRef => {
        id = docRef.id;
        console.log("Special written with ID: ", id);
        const fileName = special.image.name;
        const ext = fileName.slice(fileName.lastIndexOf("."));
        return firebase.storage().ref("specials/" + id + ext).put(special.image);
      }).then(fileData => {
        console.log("Uploaded image.");
        let url = fileData.metadata.downloadURLs[0];
        return firebase.firestore().collection("specials").doc(id).update({
          imageUrl: url,
          fullPath: fileData.metadata.fullPath
        });
      }).then(() => {
        console.log("Updated special: " + id);
      })
      .catch(error => {
        console.log("Error adding special: ", error);
      });
  },
  editSpecial({
    commit
  }, special) {
    firebase.firestore().collection("specials").doc(special.id).update({
      title: special.title,
      description: special.description,
      startDate: special.startDate,
      endDate: special.endDate
    }).then(docRef => {
      console.log("Special " + special.id + " has been updated");
    }).catch(error => {
      console.error(error);
    });
  },
  deleteSpecial({
    commit
  }, special) {
    // if there is a picture to delete
    if (special.fullPath !== undefined) {
      let imageRef = firebase.storage().ref().child(special.fullPath);
      imageRef.delete().then((result) => {
        console.log("Deleted Image");
        return firebase.firestore().collection("specials").doc(special.id).delete();
      }).then((result) => {
        console.log("Deleted special");
      }).catch(error => {
        console.error(error);
      });

    } else {
      firebase.firestore().collection("specials").doc(special.id).delete().then((result) => {
        console.log("deleted special");
      }).catch(error => {
        console.error(error);
      });
    }

  }
}

const mutations = {
  setSpecials(state, specials) {
    state.allSpecials = specials;
  },
  setSpecialToEdit(state, special) {
    state.specialToEdit = special;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};